import { Directive, Input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionsService } from '../../services/Permissions.service';


@Directive({
  selector: '[requirePermission]',
  standalone: true
})
export class RequirePermissionDirective implements OnChanges {

  @Input('requirePermission') requiredPermissions: string[] = [];

  // Support supplementaire d'une seule permission (1 string) : *requirePermission="'Permissions.Entities.Employee.Read'"
  @Input('requireSinglePermission') set singlePermission(value: string) {
    if (value) {
      this.requiredPermissions = [value];
    }
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionsService: PermissionsService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['requiredPermissions'] || changes['singlePermission']) {
      this.updateView();
    }
  }

  private updateView(): void {
    this.viewContainer.clear();

    if (this.permissionsService.UserHasAllPermissions(this.requiredPermissions)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
    // Sinon : rien n'est rendu .. structurellement (pas de DOM)
  }
}
